import styles from './index.module.scss';
import SectionPro from '../components/SectionPro';
import EFPicture from '@elem/compCommon/EFPicture';

const Map: React.FC = () => {
    return (
        <div className={`${styles.Map} GtmModuleData-section`} data-section-id={styles.Map} data-section-title={'政府と被災地をサポートする取り組み'}>
            <SectionPro
                title={
                    <div>
                        政府と被災地を <br />
                        サポートする取り組み
                    </div>
                }
            >
                <div className="wrapper">
                    <EFPicture src="https://websiteoss.ecoflow.com/upload/image/1745035133179/Vrstva_1%20(1).png" />
                    <div className="text-box">
                        <div className="title">自治体への防災支援活動</div>
                        <div className="desc">
                            EcoFlowは、自治体への防災用品の提供などを通じて社会貢献活動に取り組んで
                            います。これまでに、品川区、長崎県庁や鳥取市役所などに寄贈を行い、2023年
                            9月には東京都港区、2024年には江東区と防災支援に関する協定を締結しました。
                        </div>
                    </div>
                </div>
            </SectionPro>
        </div>
    );
};

export default Map;
